import React from 'react';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { useTreeState } from "../../../../hooks/useTreeState";
import { useAttributeState } from "../../../../hooks/useAttributeState";
import { useComponentState } from "../../../../hooks/useComponentState";

// Elemente für Baum-Darstellung definieren wenn Suchfeld nicht benutzt wird (Aufruf über SearchList.js)

export function TreeItemsFromData({ items, pa }) {
    const tree = useTreeState();
    const attr = useAttributeState();
    const comp = useComponentState();

    if (!items) return null;

    return items.map((treeItemData) => {
        const itemName = treeItemData.name;
        const children = treeItemData.children_objecttypes?.length > 0
            ? <TreeItemsFromData items={treeItemData.children_objecttypes} />
            : undefined;

        return (
            <TreeItem
                key={treeItemData.global_id}
                itemId={treeItemData.global_id}
                label={itemName}
                children={children}
                onClick={() => {
                    tree.setSelected(treeItemData);
                    tree.setSelectedItem(treeItemData.attribute);
                    attr.setIsSelected(false);
                    comp.setIsSelected(true);
                    comp.setName("");
                    comp.setCode("");
                    comp.setDesc("");
                    tree.setParent(pa);
                }}
            />
        );
    });
}
